import { FooterContainer } from "../Home/HomeElements";
import { Section, Container } from "./../Layout/layoutElement";
// import { ButtonMain } from '../button/buttonElements';
import MainButton from "../button/MainButton";
import { Link } from "react-router-dom";
import { PORTAL_BASE_URL } from "../../constants/defaultValues";

export default function Footer() {
  const Year = new Date().getFullYear();
  return (
    <Section bg="#1D2646" padding="28px 0px">
      <Container>
        <FooterContainer>
          <div className="footer_contacts">
            <div className="footer_contacts_contact">
              <h3 className="">Contact our team.</h3>
              <div className="footer_contact">
                <div className="footer_contact_item">
                  <img src="/img/mail.svg" alt="" height={28} />
                  <h4>
                    <a href="enquiries@icadpay.com">enquiries@icadpay.com</a>
                  </h4>
                </div>
                <div className="footer_contact_item">
                  <img src="/img/phone.svg" alt="" height={28} />
                  <h4>
                    <a href="tel:+2347031696993">+234 703 169 6993</a>
                  </h4>
                </div>
              </div>
            </div>
            <div className="footer_contacts_social footer_show">
              <ul className="footer_contacts_social_list">
                <li className="footer_contacts_social_item">
                  <a
                    href="https://www.facebook.com/ICADPay"
                    className="footer_contacts_social_link"
                  >
                    <img
                      src="/img/facebook.svg"
                      alt=""
                      width={20}
                      height={20}
                    />
                  </a>
                </li>
                <li className="footer_contacts_social_item">
                  <a
                    href="https://twitter.com/icadpayng"
                    className="footer_contacts_social_link"
                  >
                    <img
                      src="/img/x-social-media-white-icon.svg"
                      alt=""
                      width={20}
                      height={20}
                    />
                  </a>
                </li>
                <li className="footer_contacts_social_item">
                  <a
                    href="https://www.instagram.com/icadpay/"
                    className="footer_contacts_social_link"
                  >
                    <img
                      src="/img/instagram.svg"
                      alt=""
                      width={20}
                      height={20}
                    />
                  </a>
                </li>
                <li className="footer_contacts_social_item">
                  <a
                    href="https://www.linkedin.com/company/icadpay"
                    className="footer_contacts_social_link"
                  >
                    <img src="/img/linkden.svg" alt="" width={20} height={20} />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer_menu">
            <div className="footer_menu_nav">
              <Link to="/">
                <img src="/img/logow.png" alt="" width={116} height={39} />
              </Link>

              <ul className="footer_menu_nav_list">
                <li className="footer_menu_nav_item">
                  <Link to="/bills" className="footer_menu_nav_link">
                    Pay Bills
                  </Link>
                </li>
                <li className="footer_menu_nav_item">
                  <Link to="/" className="footer_menu_nav_link">
                    For Businessess
                  </Link>
                </li>
                <li className="footer_menu_nav_item">
                  <a
                    href={`https://icadpay.com/developers/index.html`}
                    target="_blank"
                    rel="noreferrer"
                    className="footer_menu_nav_link"
                  >
                    Documentation
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer_menu_btn">
              <a href={`/register`} rel="noreferrer">
              <MainButton text="Register" main={true} />
              </a>
            </div>
          </div>

          <div className="footer_copyright">
            <div className="footer_contacts_social footer_hidden">
              <ul className="footer_contacts_social_list">
                <li className="footer_contacts_social_item">
                  <a
                    href="https://www.facebook.com/ICADPay"
                    className="footer_contacts_social_link"
                  >
                    <img
                      src="/img/facebook.svg"
                      alt=""
                      width={20}
                      height={20}
                    />
                  </a>
                </li>
                <li className="footer_contacts_social_item">
                  <a
                    href="https://twitter.com/icadpayng"
                    className="footer_contacts_social_link"
                  >
                    <img
                      src="/img/x-social-media-white-icon.svg"
                      alt=""
                      width={20}
                      height={20}
                    />
                  </a>
                </li>
                <li className="footer_contacts_social_item">
                  <a
                    href="https://www.instagram.com/icadpay/"
                    className="footer_contacts_social_link"
                  >
                    <img
                      src="/img/instagram.svg"
                      alt=""
                      width={20}
                      height={20}
                    />
                  </a>
                </li>
                <li className="footer_contacts_social_item">
                  <a
                    href="https://www.linkedin.com/company/icadpay"
                    className="footer_contacts_social_link"
                  >
                    <img src="/img/linkden.svg" alt="" width={20} height={20} />
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer_copyright_rights">
              <h4>{Year} Icadpay. All Rights Reserved</h4>
            </div>
            <div className="footer_copyright_policy">
              <a href="/user/privacy-policy" className="">
                Privacy Policy
              </a>
              <a href="/user/privacy-policy#cookies" className="">
                Cookies
              </a>
            </div>
          </div>
        </FooterContainer>
      </Container>
    </Section>
  );
}
